module.exports = __webpack_public_path__ + "img/Ellipse 23@2x.bb982b88.png";